// Auto-generated translation for ar.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:49:37.044694+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "لأصحاب الخيول",
    title: "كل شيء لفرسك. في تطبيق واحد.",
    subtitle: "أدِر الصحة والتدريب والجدولة والمختصين من ملف واحد منظم.",
    primaryCTA: {
      label: "ابدأ مجاناً",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "اعرض Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "ملف الحصان — الوزن والتطعيم وEquiCoach والتغذية والتدريب في شاشة واحدة",
      caption: "فرسك، صورة كاملة في لمحة واحدة.",
    },
    problem: "على الأرجح أنك تحتفظ بمواعيدك وصورك وتدريباتك وتغذيتك ومعلوماتك الصحية موزعةً في مجموعات واتساب وأكوام الأوراق وتطبيقات متفرقة. هذا يجعلك تفقد الصورة الكاملة.",
    solution: "يحوّل EquiSight فرسك إلى ملف رقمي متكامل يرافقك أينما ذهبت.",
    benefits: [
      "ملف شامل لكل حصان على حدة",
      "الصحة وحداد الخيل وطبيب الأسنان والمعالج الفيزيائي في مكان واحد",
      "جدول أعمال مع تذكيرات ذكية",
      "صور وملاحظات وسجل تاريخي بلا حدود",
      "نسخ احتياطي لجميع بياناتك مع Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "حصان واحد · مجاني دائماً",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "خيول متعددة + نسخ احتياطي",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "مستعد للبداية؟",
      title: "ابدأ اليوم بتسجيل فرسك الأول.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "المزيد من الخيول. المزيد من الإشراف. المزيد من اليقين.",
    subtitle: "قم بالترقية إلى Premium وأدِر جميع خيولك دون قيود — مع الذكاء الكامل لـ EquiCoach.",
    primaryCTA: {
      label: "ابدأ 14 يومًا مجانًا",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "جميع الأسعار",
      href: "/#pricing",
    },
    audience: "لأصحاب الخيول والفرسان الرياضيين ومربّي الخيول الذين يمتلكون أكثر من حصان.",
    features: [
      "إضافة خيول بلا حدود",
      "السجل الكامل لكل حصان",
      "النسخ الاحتياطي للبيانات",
      "رؤى EquiCoach المتقدمة",
      "تنبيهات ذكية وتخطيط متكامل",
      "الصحة والتدريب مرتبطان بالكامل",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "أقل من €0,17 في اليوم",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "هل أنت مستعد؟",
      title: "قم بالترقية إلى Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "لراكبي الإسطبلات",
    title: "تطور مستمر، حتى بدون امتلاك حصان.",
    subtitle: "تابع دروسك وتدريباتك وتطورك داخل EquiSight — بأقل من ثمن فنجان قهوة شهرياً لأمك أو أبيك. أو آيسكريم بالكريمة الطازجة.",
    primaryCTA: {
      label: "ابدأ مع Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "كيف يعمل؟",
      href: "#features",
    },
    problem: "بوصفك راكباً في إسطبل، غالباً لا تمتلك حصاناً خاصاً بك، لكنك تريد التطور ومتابعة دروسك وأهدافك والخيول التي تركبها.",
    solution: "وظائف الإسطبل مدمجة بشكل افتراضي في Premium — تابع تطورك الشخصي واستعرض خيول الإسطبل المرتبطة بصلاحية قراءة فقط.",
    features: [
      "تتبع جلسات التدريب",
      "تحديد الأهداف",
      "متابعة التقدم",
      "استعراض خيول الإسطبل بالاسم والصورة",
      "لا يوجد وصول إلى البيانات الصحية الخاصة",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "شهرياً · وظائف الإسطبل مشمولة",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "انضم إلينا",
      title: "ابدأ كراكب في الإسطبل.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "للمدارس الفروسية والإسطبلات",
    title: "اجعل مدرسة الفروسية الخاصة بك متاحة رقمياً لكل فارس.",
    subtitle: "امنح الفرسان ارتباطاً بالخيول والدروس والتقدم — دون مشاركة بيانات الإسطبل الحساسة.",
    primaryCTA: {
      label: "اطلب الوصول",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "استعرض الوحدات",
      href: "#features",
    },
    audience: "يساعد EquiSight مدارس الفروسية والإسطبلات على إبقاء الفرسان أكثر انخراطاً وتميزاً رقمياً.",
    features: [
      "إتاحة خيول المدرسة للفرسان",
      "اسم وصورة لكل حصان",
      "ربط الفرسان بالخيول",
      "وصول للقراءة فقط للبيانات الحساسة",
      "تاريخ الدروس والتدريب في مكان واحد",
      "إدارة المستخدمين بالأدوار",
    ],
    benefits: [
      "ارتباط أقوى مع الفرسان",
      "مظهر أكثر احترافية",
      "خدمة رقمية إضافية للأعضاء",
      "مصدر دخل جديد عبر استخدام التطبيق",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "شهرياً · وظائف مدرسة الفروسية مدرجة للفرسان",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "هل أنت مستعد؟",
      title: "فعّل وحدة مدرسة الفروسية.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "وحدة التربية",
    title: "تحكم كامل في دورة التكاثر والحمل وتطور المهر.",
    subtitle: "الوحدة المتكاملة للتربية لأصحاب الأفراس والمربين — من التلقيح حتى المهر، في جدول زمني واحد.",
    primaryCTA: {
      label: "تفعيل وحدة التربية",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "استعرض الميزات",
      href: "#features",
    },
    audience: "للمربين وأصحاب الأفراس والإسطبلات التي تدير عدة أفراس.",
    features: [
      "تتبع دورة التكاثر",
      "تسجيل فترة الشياع",
      "تسجيل بيانات التلقيح",
      "العد التنازلي للفحوصات بالموجات فوق الصوتية",
      "جدولة فحوصات الحمل",
      "شجرة النسب والسلالة",
      "تطور المهر",
      "نظرة عامة على جميع الأفراس الحوامل",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "شهرياً · وحدة التربية مضمّنة في خطة Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "ابدأ اليوم",
      title: "ابدأ بإدارة عمليات التربية.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "وحدة الحداد",
    title: "اعمل بذكاء أكبر كحداد. سجّل كل شيء باحترافية.",
    subtitle: "الجدول الزمني، والصور، والملاحظات، وتاريخ العلاج في وحدة واحدة — تواصل أوضح، وملف أقوى.",
    primaryCTA: {
      label: "ابدأ كحداد",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "اطّلع على الباقة المهنية",
      href: "/professional",
    },
    audience: "للحدادين الذين يرغبون في تحسين التنظيم، وتوثيق الأدلة، والتواصل مع العملاء.",
    features: [
      "جدول زمني خاص",
      "مواعيد لكل عميل",
      "عرض ملفات الخيول",
      "إضافة صور قبل وبعد",
      "تدوين العلاج",
      "تسجيل النصائح والملاحظات",
      "إرسال إشعار الوقت المتوقع للوصول إلى العميل: \"الحداد في الطريق\"",
    ],
    benefits: [
      "عمل أكثر احترافية",
      "تواصل أوضح وأقل سوء فهم",
      "بناء ملف أفضل",
      "حماية أقوى عند المسؤولية القانونية",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "شهرياً · وحدة الحداد مضمّنة في Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "مستعد؟",
      title: "فعّل وحدة الحداد.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "وحدة طب أسنان الخيول",
    title: "ملف طب أسنان متكامل لكل حصان.",
    subtitle: "سجّل النتائج والعلاجات والمتابعة مباشرةً في EquiSight.",
    primaryCTA: {
      label: "ابدأ كطبيب أسنان خيول",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "اطّلع على باقة Professional",
      href: "/professional",
    },
    audience: "أطباء أسنان الخيول والأطباء البيطريون والعيادات الراغبة في العمل بأسلوب منظّم.",
    features: [
      "تسجيل فحص الأسنان",
      "النتائج لكل جلسة علاج",
      "إضافة الصور",
      "تقرير لصاحب الحصان",
      "نصائح المتابعة",
      "السجل التاريخي لكل حصان",
      "جدولة موعد جديد",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "شهرياً · وحدة طب أسنان الخيول مدرجة في Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "هل أنت مستعد؟",
      title: "فعّل وحدة طب أسنان الخيول.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "وحدة العلاج الطبيعي / هشاشة العظام",
    title: "تتبع الجسم والحركة والتعافي باحترافية.",
    subtitle: "لأخصائيي العلاج الطبيعي ومعالجي الهشاشة الذين يرغبون في متابعة الخيول بشكل منهجي.",
    primaryCTA: {
      label: "ابدأ كأخصائي علاج طبيعي / هشاشة عظام",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "عرض الحزمة Professional",
      href: "/professional",
    },
    features: [
      "تسجيل المعلومات الأولية لكل حصان",
      "تسجيل نتائج الفحص الجسدي",
      "إضافة الصور ومقاطع الفيديو",
      "إعداد تقرير العلاج",
      "مشاركة التمارين وخطة المتابعة",
      "متابعة مسار التعافي",
      "سجل تاريخي لكل حصان",
    ],
    benefits: [
      "رؤية أوضح عبر الزمن",
      "تقارير احترافية",
      "تواصل واضح مع المالك والمدرب والفارس",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "شهرياً · وحدة العلاج الطبيعي / هشاشة العظام مضمّنة في Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "هل أنت مستعد؟",
      title: "فعّل وحدة العلاج الطبيعي / هشاشة العظام.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "وحدة المدرب",
    title: "درّب الفرسان باستخدام البيانات والأهداف والتقدم.",
    subtitle: "اجعل التدريب قابلاً للقياس والإرشاد أكثر احترافية — لفارس واحد أو أكثر.",
    primaryCTA: {
      label: "ابدأ كمدرب",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "اطّلع على باقة Pro",
      href: "/#pricing",
    },
    audience: "للمعلمين والمدربين والمرشدين الذين يتابعون فرسانًا أو خيولًا متعددة.",
    features: [
      "ربط الفرسان",
      "متابعة الخيول",
      "تحديد أهداف التدريب",
      "تقديم الملاحظات",
      "تحليل نتائج المسابقات",
      "عرض التقدم لكل ثنائي",
      "استخدام تحليلات البروتوكول لتركيز التدريب",
    ],
    benefits: [
      "إرشاد أفضل",
      "هيكل أكثر نظامًا",
      "تواصل أكثر احترافية",
      "علاقة أقوى مع العملاء",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "شهريًا · وحدة المدرب مضمّنة في Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "هل أنت مستعد؟",
      title: "فعّل وحدة المدرب.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "تحليل المنافسة",
    title: "من البروتوكول إلى تحسين الأداء.",
    subtitle: "قم بتحميل بروتوكول المنافسة الخاص بك واكتشف أين تضيع نقاطك — ليس فقط مشاهدة نتيجتك، بل فهم كيف تتحسن.",
    primaryCTA: {
      label: "حلّل بروتوكولك الأول",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "استعرض Premium",
      href: "/premium",
    },
    features: [
      "تحميل صورة البروتوكول",
      "معالجة الجهة الأمامية والخلفية",
      "التعرف على الفئة ورقم الاختبار وعضو لجنة التحكيم",
      "تحليل الدرجات لكل عنصر",
      "تلخيص التعليقات",
      "عرض نقاط القوة والضعف",
      "اتجاهات كل مجموعة حصان وفارس",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "شهريًا · تحليل المنافسة مشمول من Premium فصاعدًا",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "هل أنت مستعد؟",
      title: "ابدأ بتحليل المنافسة.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "باقة Professional",
    title: "للمحترفين العاملين مع الخيول.",
    subtitle: "سواء كنت بيطري حوافر، طبيب أسنان بيطري، معالج فيزيائي، معالج عظمي، أو مدرباً: تعاونوا معاً في ملف رقمي واحد للخيل.",
    primaryCTA: {
      label: "ابدأ كمحترف",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "استعرض الوحدات المنفردة",
      href: "#features",
    },
    audience: "تجمع باقة Professional جميع الوحدات المتخصصة في اشتراك واحد.",
    features: [
      "وحدة بيطري الحوافر",
      "وحدة طبيب الأسنان البيطري",
      "وحدة العلاج الفيزيائي / العظمي",
      "الجدول الزمني وإدارة العملاء",
      "ملفات الخيول والتقارير",
      "سجل العلاجات وبناء الملف الطبي",
      "التواصل مع المالك",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "شهرياً · جميع الوحدات المتخصصة مشمولة",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "مستعد؟",
      title: "اختر Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "أرقام الطوارئ للحصان",
    title: "المساعدة الصحيحة دائمًا في متناول يدك.",
    subtitle: "في حالات الطوارئ، كل ثانية تُحسب. مع EquiSight، تجد جميع بيانات الاتصال المهمة لحصانك في متناول يدك فورًا — نقرة واحدة وتتصل.",
    primaryCTA: {
      label: "جهّز جهات اتصال الطوارئ الخاصة بك",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "ابدأ مجانًا مع EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "جهات اتصال الطوارئ — اتصل مباشرةً أو تواصل عبر WhatsApp أو احصل على الاتجاهات إلى الطبيح البيطري والعيادة وحداد الخيل",
      caption: "نقرة واحدة. بلا ذعر أو بحث.",
      embeddedFrame: true,
    },
    problem: "حصانك يعاني — مغص، إصابة، ذعر. ويبدأ البحث المحموم. من تتصل به؟ هل لديك الرقم الصحيح؟ هل هذا رقم الطوارئ؟ يضيع وقت ثمين.",
    solution: "مع EquiSight، كل شيء في متناول يدك فورًا. لا بحث. لا تردد. نقرة واحدة وتتواصل.",
    scenario: {
      title: "تخيّل — حصانك يُظهر أعراض المغص.",
      steps: [
        "تفتح EquiSight",
        "تنقر على \"الطبيب البيطري\"",
        "تتصل مباشرةً",
      ],
      tagline: "بلا توتر. بلا بحث. فقط تصرف.",
    },
    features: [
      "جميع أرقام الطوارئ في مكان واحد",
      "اتصال بنقرة واحدة من داخل التطبيق",
      "مراسلة عبر WhatsApp بنقرة واحدة",
      "الانتقال المباشر إلى العنوان",
      "قائمة جهات اتصال خاصة لكل حصان",
      "طبيب بيطري، عيادة، حداد، طبيب أسنان، معالج طبيعي",
      "العنوان وتعليمات الطريق متاحة فورًا",
      "ميّز أرقامك المفضلة بنجمة",
      "أرقام الطوارئ (112، 144) دائمًا في الأعلى",
    ],
    benefits: [
      "هدوء وسيطرة في حالات الطوارئ",
      "جميع العاملين في الإسطبل لديهم الأرقام ذاتها في متناول أيديهم",
      "لا مزيد من بطاقات الأعمال المنسية",
      "استجب بشكل أسرع بثوانٍ في حالات الطوارئ",
    ],
    audience: "لأصحاب الخيول والمربين والمدربين والإسطبلات — لكل من هو مسؤول عن حصان.",
    showcase: {
      eyebrow: "مُعدّ مسبقًا من أجلك",
      title: "13 فئة من جهات الاتصال — جاهزة للتعبئة.",
      description: "من الطبيب البيطري وعيادة الطوارئ إلى صانع السروج والمدرب ومدير المرعى. يعرف EquiSight عالمك ويُجهّز لك حقول الاتصال الصحيحة مسبقًا. انقر، أدخل البيانات، انتهيت.",
      bullets: [
        "الطوارئ والصحة — طبيب بيطري، طوارئ، عيادة، خط التسمم",
        "الرعاية اليومية — حداد، طبيب أسنان، معالج طبيعي، مدرب",
        "الإسطبل والمرعى — صاحب الإسطبل، مدير المرعى، إسطبل الإيواء",
        "العلف والمستلزمات — موردو الدريس والعلف المركز والتبن",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "شاشة إدارة جهات اتصال الطوارئ — جميع جهات الاتصال المقترحة حسب الفئة",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "قائمة تحقق لأرقام طوارئ الحصان",
      items: [
        "طبيب بيطري",
        "عيادة طوارئ (24/7)",
        "سيارة إسعاف الحيوانات · 144",
        "حداد الخيل",
        "جهة اتصال احتياطية",
        "رقم الإنذار العام · 112",
      ],
      cta: {
        label: "افتح في EquiSight وأدخل البيانات مباشرةً",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "أرقام الطوارئ",
          price: "Gratis",
          note: "مجاني دائمًا · للجميع، في كل الاشتراكات",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "تأكد من استعدادك",
      title: "قبل أن تحتاج إليه.",
      href: "/#waitlist",
    },
    microcopy: [
      "بلا التزامات",
      "جاهز خلال دقيقتين",
      "قابل للتعديل في أي وقت",
    ],
  },
};

export default LANDINGS;
